export const showcase = [
  "21149247_828713540642724_2806408468171325440_n.jpg",
  "26153636_1968460283406914_7972352547199385600_n.jpg",
  "26428298_391165934671036_6487258632697151488_n.jpg",
  "27893231_326576694527825_5342645068014551040_n.jpg",
  "28427891_601968650148714_8156638766258192384_n.jpg",
  "29090216_1622903774492137_5909288371187875840_n.jpg",
  "29095745_1790670070997656_424080114414780416_n.jpg",
  "30077049_191756728108133_8427143314163105792_n.jpg",
  "30077262_425779011203673_5594479775335841792_n.jpg",
  "30077790_191423464917630_7790722889967206400_n.jpg",
  "30085322_2058058677745331_1455563214023557120_n.jpg",
  "30830501_1703946009694642_5175957413026594816_n.jpg",
  "30855785_227003788050696_4665697654536142848_n.jpg",
  "30940780_2053491171642976_6580363585120108544_n.jpg",
  "31023865_2059222617649978_4830262225585307648_n.jpg"
]


// WEBPACK FOOTER //
// ./src/components/Photographer/data.js